import SkeletonLoader from './index';

const TeacherDetailsSkeleton = () => {
  return (
    <div className="flex flex-col gap-6">
      {/* Header / Actions */}
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <SkeletonLoader width={288} height={40} className="rounded-lg" />
          <SkeletonLoader width={150} height={40} className="rounded-lg" />
        </div>
        <SkeletonLoader width={160} height={40} className="rounded-lg" />
      </div>

      {/* Teacher Profile */}
      <div className="border border-neutral-200 rounded-2xl p-6 bg-white">
        <div className="flex items-start justify-between">
          <div className="flex gap-6">
            <SkeletonLoader
              variant="circle"
              width={100}
              height={100}
              className="rounded-full"
            />
            <div className="space-y-2 py-2">
              <SkeletonLoader width={200} height={32} />
              <SkeletonLoader width={150} height={24} />
              <div className="flex gap-2 pt-2">
                <SkeletonLoader
                  width={100}
                  height={24}
                  className="rounded-full"
                />
                <SkeletonLoader
                  width={100}
                  height={24}
                  className="rounded-full"
                />
              </div>
            </div>
          </div>
          <SkeletonLoader width={100} height={40} />
        </div>
        <div className="grid grid-cols-4 gap-4 mt-8 pt-6 border-t border-neutral-200">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="space-y-2">
              <SkeletonLoader width={120} height={20} />
              <SkeletonLoader width={150} height={24} />
            </div>
          ))}
        </div>
      </div>

      {/* Assigned Classes */}
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <SkeletonLoader width={200} height={28} />
          <SkeletonLoader width={100} height={40} />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="border border-neutral-200 p-4 rounded-2xl space-y-4 bg-white"
            >
              <div className="flex items-center justify-between">
                <SkeletonLoader width={150} height={24} />
                <SkeletonLoader
                  width={80}
                  height={24}
                  className="rounded-full"
                />
              </div>
              <div className="flex gap-4">
                {[1, 2, 3].map((j) => (
                  <SkeletonLoader
                    key={j}
                    variant="circle"
                    width={32}
                    height={32}
                  />
                ))}
              </div>
              <div className="flex items-center justify-between pt-2">
                <SkeletonLoader width={100} height={20} />
                <SkeletonLoader width={60} height={20} />
              </div>
              <SkeletonLoader
                width="100%"
                height={8}
                className="rounded-full"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeacherDetailsSkeleton;
